module.exports = __webpack_public_path__ + "img/annuel.1f57fb7a.png";